import { c as _c } from "react/compiler-runtime";
import { Badge } from './Badge';
import type { StatusMapper } from '../utils/status-mappings';
export interface StatusBadgeProps {
  /** Status mapper created via `createStatusMapper` (only `getLabel`/`getVariant` are used) */
  mapper: Pick<StatusMapper<string>, 'getLabel' | 'getVariant'>;
  /** Status value to render */
  status: string;
}

/**
 * Renders a status as a Badge using a status mapper's label and variant.
 *
 * @example
 * ```tsx
 * <StatusBadge mapper={paymentStatusMapper} status={payment.status} />
 * ```
 */
export function StatusBadge(t0) {
  const $ = _c(9);
  const {
    mapper,
    status
  } = t0;
  let t1;
  if ($[0] !== mapper || $[1] !== status) {
    t1 = mapper.getVariant(status);
    $[0] = mapper;
    $[1] = status;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== mapper || $[4] !== status) {
    t2 = mapper.getLabel(status);
    $[3] = mapper;
    $[4] = status;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = <Badge variant={t1}>{t2}</Badge>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}